var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-section",attrs:{"id":"blogs"}},[_c('Blog1'),_c('Blog2'),_c('Blog3'),_c('Blog4'),_c('Blog5'),_c('Blog6'),_c('Blog7')],1)}
var staticRenderFns = []

export { render, staticRenderFns }